var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5E7B1A25-17A6-497C-BF38-01A97402ADC6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-Integrations",
    transform: "translate(-876.000000, -396.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PushNotifications",
    transform: "translate(876.000000, 396.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7495406,40.7500656 C30.7495406,43.6485544 28.398095,46 25.4996063,46 C22.6011175,46 20.2496719,43.6485544 20.2496719,40.7500656 L30.7495406,40.7500656 Z M25.4996063,4.00052499 C27.0478119,4.00052499 28.5230435,4.29977125 29.8848764,4.8237147 C29.3383583,5.89522631 28.9997375,7.09011137 28.9997375,8.37529531 C28.9997375,12.718041 32.5324183,16.2517719 36.8746391,16.2517719 C37.1717854,16.2517719 37.4552818,16.1955976 37.7440282,16.1646229 C37.7461282,16.1919226 37.7492781,16.2207972 37.7492781,16.2501969 L37.7492781,16.2501969 L37.7492781,28.4998688 C37.7492781,31.4015075 40.1012487,33.7498031 42.9997375,33.7503281 L42.9997375,33.7503281 L42.9997375,37.2499344 L8,37.2499344 L8,33.7503281 C10.8990138,33.7503281 13.2499344,31.3988825 13.2499344,28.5003937 L13.2499344,28.5003937 L13.2499344,16.2507219 C13.2499344,9.48670642 18.7345408,4.00052499 25.4996063,4.00052499 Z M36.8746391,4 C39.2927588,4 41.2499344,5.95875052 41.2499344,8.37529531 C41.2499344,10.7934151 39.2927588,12.7516406 36.8746391,12.7516406 C34.4565193,12.7516406 32.4993438,10.7934151 32.4993438,8.37529531 C32.4993438,5.95875052 34.4565193,4 36.8746391,4 Z",
    id: "Combined-Shape",
    fill: "#090F36",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushNotifications);
export default __webpack_public_path__ + "static/media/PushNotifications.1a255ccaafe3f5117d618524854049be.svg";
export { ForwardRef as ReactComponent };